import FeatureFlagsModule from "./feature_flags.module";

//! IMPORTANT keep aligned with the following three Angular enums
// page-flag-keys.enum.ts
// feature-flag-keys.enum.ts
// environment-flag-keys.enum.ts

FeatureFlagsModule.constant("FeatureFlags", {
    TrackerInviteCoworkers: "tracker-invite-coworkers",
    TrackerAsLandingPage: "tracker-as-landing-page",
    TemplateEditorDurations: "template-editor-durations",
    TemplateEditorLabour: "template-editor-labour",
    TemplateEditorConfirmationTeams: "template-editor-confirmation-teams",
    TemplateEditorQaChecklist: "template-editor-qa-checklist",
    TrackerInlineLookaheadDates: "tracker-inline-lookahead-dates",
    DashboardsFullAccess: "dashboards-full-access",
    TeamsAllowOnlyAssigningFullAccess: "teams-allow-only-assigning-full-access",
    // Project Settings Features
    ProjectSettingsMobileApp: "project-settings-mobile-app",
    ProjectSettingsIssueConfirmation: "project-settings-issue-confirmation",
    ProjectSettingsEmails: "project-settings-emails",
    // Project Control Center
    ProjectControlCenterDeliverables: "project-control-center-deliverables",
    ProjectControlCenterQuality: "project-control-center-quality",
    ProjectControlCenterRunRatePerformance:
        "project-control-center-run-rate-performance",
    ProjectControlCenterDrilldown: "project-control-center-drilldown",
    // Internal Only Features
    InternalUserInfo: "internal-user-info",
});

FeatureFlagsModule.constant("PageFlags", {
    PageNotMappedToFeatureFlagYet: "page-not-mapped-to-feature-flag-yet",
    PerformanceDashboardPro: "performance-dashboard-pro",
    VisualTrackers: "visual-trackers",
    Deliverables: "deliverables",
    Notes: "notes",
    ProjectSettings: "project-settings",
    ProjectStructure: "project-structure",
    ImportExport: "import-export",
    QaChecklists: "qa-checklists",
    NoteTemplates: "note-templates",
    LeanPlanning: "lean-planning",
    CommercialValuation: "commercial-valuation",

    RequestAccessDeliverables: "request-access-deliverables",
    RequestAccessNotes: "request-access-notes",
    RequestAccessLeanPlanning: "request-access-lean-planning",
    RequestAccessCommercialProDashboard: "request-access-commercial-valuation",
    RequestAccessVisualTrackers: "request-access-visual-trackers",
    RequestAccessQAChecklists: "request-access-qa-checklists",
    SiteDiary: "site-diary",
});

FeatureFlagsModule.constant("EnvironmentFlags", {
    AllowTemplateOverwrite: "allow-template-overwrite",
    ShowCsRequest: "show-cs-request-action",
    ShowDeliverablesDependencies: "show-deliverables-dependencies",
    ShowSchedulingMode: "show-scheduling-mode",
    DeprecatedFeatureToRemoveSoon: "deprecated-feature-to-remove-soon",
    ShowOldImports: "show-old-imports",
    ImportDwfxVisualization: "import-dwfx-visualization",
    ShowInspectionTeams: "show-inspection-teams",
    DisableViewportWarning: "disable-viewport-warning",
    VisualizationEditorDrawAndEdit: "visualization-editor-draw-and-edit",
    GenerateCustomDemoProgress: "generate-custom-demo-progress",
    ProcessTemplateEditorV2: "process-template-editor-v2",
    ShowWitnessAndHoldPointApprovalTypes:
        "show-witness-and-hold-point-approval-types",
});
